import { Clickable, Row, Text } from 'components';
import { theme } from 'lib';
import { useSelector } from 'react-redux';

const FilterItem = ({ text, active, onClick }) => {
  return (
    <Clickable onClick={onClick}>
      <Row
        noFlex
        bg={active ? theme.SECONDARY : theme.GREY_10}
        pad="9px 24px"
        hasRadius="32px"
        marg="0 8px 0 0"
      >
        <Text med col={active ? '#fff' : '#000'}>
          {text}
        </Text>
      </Row>
    </Clickable>
  );
};

const Filters = ({ filter, handleFilterChange }) => {
  const { isMobile } = useSelector((state) => state.appState);

  return (
    <Row noFlex wid={isMobile && '100%'} pad="16px 0">
      <Row noFlex pad="0 16px" wid="100%">
        <Row noFlex>
          <FilterItem
            text={'Shoutout to Athletes'}
            active={filter === 'shoutout-to-athletes'}
            onClick={() => handleFilterChange('shoutout-to-athletes')}
          />

          <FilterItem
            text={'PAMEO'}
            active={filter === 'shoutout-from-athletes'}
            onClick={() => handleFilterChange('shoutout-from-athletes')}
          />

          <FilterItem
            text={'F2F'}
            active={filter === 'one-on-one-connect'}
            onClick={() => handleFilterChange('one-on-one-connect')}
          />

          <FilterItem
            text={'Subscriptions'}
            active={filter === 'subscriptions'}
            onClick={() => handleFilterChange('subscriptions')}
          />

          <FilterItem
            text={'Shoutout to Teams'}
            active={filter === 'shoutout-to-teams'}
            onClick={() => handleFilterChange('shoutout-to-teams')}
          />
        </Row>
      </Row>
    </Row>
  );
};

export default Filters;
